import React from 'react';

const CapabilitiesTable = () => {
  return (
    <>
      {/* What you can do with ASI1 */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">What you can do with ASI1</h3>
      <p className="text-gray-700 leading-relaxed mb-6">
        ASI1 is designed to empower enterprises at scale with strong performance across benchmark evaluations for reasoning, math, coding, and fluency in Web3 protocols and decentralized systems.
      </p>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-12">
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg">
            <thead className="bg-blue-100">
              <tr>
                <th className="text-left p-4 border-b font-semibold">Capability</th>
                <th className="text-left p-4 border-b font-semibold">Enables you to...</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-4 border-b font-medium">Text and code generation</td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Develop smart contracts and DeFi protocols with Web3-native understanding</li>
                    <li>• Create production-level agentic workflows and autonomous trading systems</li>
                    <li>• Build DeFi protocol integrations and multi-protocol workflows</li>
                    <li>• Conduct complex financial forecasts and yield farming strategies</li>
                    <li>• Support compliance use cases requiring technical analysis of blockchain data</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 border-b font-medium">Vision and analytics</td>
                <td className="p-4 border-b">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Process and analyze on-chain data visualizations and market charts</li>
                    <li>• Generate code from blockchain architecture diagrams and protocol specifications</li>
                    <li>• Extract insights from DeFi dashboard metrics and trading interfaces</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="p-4 font-medium">Agent orchestration</td>
                <td className="p-4">
                  <ul className="space-y-1 text-gray-700">
                    <li>• Coordinate multi-agent systems for complex DeFi operations</li>
                    <li>• Enable autonomous decision-making with Web3 tool integration</li>
                    <li>• Execute multi-step workflows across different blockchain networks</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CapabilitiesTable;
